"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Post } from "@/shared/libs/axios/request";
import { stockKeys } from "@/entities/stock";
import type { CreateVendorRequest, VendorResponse } from "@stocks/shared";

export const useCreateVendor = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (values: CreateVendorRequest) =>
      Post<VendorResponse, CreateVendorRequest>("/v1/stocks/vendors", values),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: [stockKeys.vendors] });
      toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "공급업체 등록에 실패했습니다."),
  });
};
